import { Alert } from "@mui/material";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../api/logout";
const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];

// timeout = 3600000 (1hrs set);
// timeout = 1800000 (half hrs);
// timeout = 300000  (5min)

const AutoLogouthook = ({ children, timeout = 3600000 }) => {
  const timerRef = useRef(null); // Use ref to persist the timer value across renders
  const navigate = useNavigate();
  
  try {
    const handleLogoutTimer = () => {
      timerRef.current = setTimeout(() => {
        // clears any pending timer.
        resetTimer();
        // Listener clean up. Removes the existing event listener from the window
        Object.values(events).forEach((item) => {
          window.removeEventListener(item, resetTimer);
        });
        // logs out user
        logoutAction(); //This will redirect user to Loginpage
        logout(); // this is a API call where if user is using GPTkey and auto logout happens it will reset the GPTKEY Column to LIMITED .
        console.log("User has been logged out due to inactivity."); // Log message after logout
        Alert("User has been logged out due to inactivity.");
      }, timeout);
    };

    // this resets the timer if it exists.
    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };

    useEffect(() => {
      Object.values(events).forEach((event) => {
        window.addEventListener(event, () => {
          resetTimer();
          handleLogoutTimer();
        });
      });

      // Cleanup event listeners on component unmount
      return () => {
        Object.values(events).forEach((event) => {
          window.removeEventListener(event, resetTimer);
        });
        resetTimer(); // Clear the timer when unmounting
      };
    }, []);

    // logs out user by clearing out auth token in localStorage and redirecting url to /signin page.
    const logoutAction = () => {
      localStorage.clear();
      sessionStorage.removeItem("isLoggedIn");
      navigate(`/`);
    };

    return children;
  } catch (err) {
    console.log("Error in Autologout : ", err.message);
    console.log("Error Message",err.stack);
  }
};

export default AutoLogouthook;
